// extracted by mini-css-extract-plugin
export default {"properties":"properties_properties__ligzF","cardWrapper":"properties_cardWrapper__iEZM7","card":"properties_card__4id-H"};